// extracted by mini-css-extract-plugin
export var framesContainer = "pageMostAlbums-module--framesContainer--uetiO";
export var frames = "pageMostAlbums-module--frames--fMaQK";
export var frame = "pageMostAlbums-module--frame--RBYGc";
export var frame1 = "pageMostAlbums-module--frame1--uLhGG";
export var frame2 = "pageMostAlbums-module--frame2--u0gug";
export var frame3 = "pageMostAlbums-module--frame3--s1MIs";